export {
  mapFhirToPractitionerRole,
  mapPractitionerRoleToFhir,
} from './mappings';

export type {
  GetPractitionerRolesInput,
  GetPractitionerRolesResponse,
  PractitionerRole,
} from './schema';
export {
  GetPractitionerRolesInputSchema,
  GetPractitionerRolesResponseSchema,
  PractitionerRoleSchema,
} from './schema';
